import { render, staticRenderFns } from "./ProjectCampaignsCard.vue?vue&type=template&id=91f5fa52"
import script from "./ProjectCampaignsCard.vue?vue&type=script&lang=js"
export * from "./ProjectCampaignsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports